import { defineComponent as _defineComponent } from 'vue'

import { ReviewerAttributeAnswerResponse } from "@/apiRequests/models/reviewerAttributeAnswerResponse";

interface Props {
	/**
	 * 投稿者プロフィール回答取得。
	 */
	reviewerAttributeAnswers: ReviewerAttributeAnswerResponse[];
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    reviewerAttributeAnswers: { type: Array, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * 投稿者プロフィール回答取得。
	 */
	reviewerAttributeAnswers: ReviewerAttributeAnswerResponse[];
}
/**
 * 投稿者プロフィール回答。
 */


const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})